import axios from 'axios';
import axiosRetry from  'axios-retry';
import { showModalAction} from './action/modalAction';
import { store } from "./storeConfig/store";

const getToken = () => {
  try {
    const serializedState = localStorage.getItem('loggedInUserBabaPrakerja')
    if (serializedState === null) {
      return null
    }
    return JSON.parse(serializedState).token
  } catch (err) {
    const serializedState = localStorage.getItem('loggedInUserBabaPrakerja') //ini
    if (serializedState === null) {
      return null
    }
    return JSON.parse(serializedState).token
  }
}

export const api = axios.create({
  baseURL: process.env.REACT_APP_URI_API,
  headers: { "Content-type": "application/json" }
});

api.defaults.timeout = 1000000;

api.interceptors.request.use (
  config => {
    const token = getToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => Promise.reject(error)
);

api.interceptors.response.use((response) => {
  return response;
}, (error) => {
  const { dispatch } = store
  if(error.response && error.response.status === 401) {
    dispatch(showModalAction({
      title: 'Sesi Habis',
      body: 'Sesi anda habis, silahkan login ulang.',
      relog: true
    }));
  } else if(error.response && error.response.status === 503){
    dispatch(showModalAction({
      title: 'Maintenance',
      body: "Mohon maaf saat ini sedang ada perbaikan layanan.",
      relog: true
    }));
  }
  else if(error.response && error.response.status === 405){
    dispatch(showModalAction({
      title: 'Perhatian!',
      body: "Kamu dapat menghubungi CS pada hari Senin - Jumat : 07:00 - 21:00 WIB dan hari Sabtu - Minggu : 09:00 - 17:00 WIB",
      refresh: false
    }));
  }
  else {
    return axios(error.config);
    // return Promise.reject(error)
  }
});

axiosRetry(api, {
  retries: 3, // number of retries
  retryDelay: (retryCount) => {
    if(retryCount === 3){
      store.dispatch(showModalAction({
        title: 'Perhatian!',
        body: "Terjadi kesalahan. Silahkan ulangi kembali.",
        refresh: true
      }));
    }
    console.log(`retry attempt: ${retryCount}`);
    return retryCount * 2000; // time interval between retries
  },
});